import { every, identity, flatten } from 'lodash/fp';
export function everyTrue() {
  for (var _len = arguments.length, conditions = new Array(_len), _key = 0; _key < _len; _key++) {
    conditions[_key] = arguments[_key];
  }

  return every(identity, flatten(conditions));
}
export default everyTrue;